import { useEffect, useRef } from 'react';

export function useRenderCounter(name: string, extra?: Record<string, any>) {
  const count = useRef(0);
  count.current++;

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    console.log(`🧭 RENDER #${count.current} — ${name}`, extra ?? '');
  });
}
